/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';
import { Button, Grid, Link } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { fetchContactProfile } from '../../common/services/proxyServices';
import { clearFormInput, dateValidation, handleFormInputChange, handleFormValidation, userNameValidation } from '../../common/utilities/CustomValidatorUtil';
import { formatDate, handleDateChange } from '../../common/utilities/CustomFormatUtil';
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import { ImageComponent } from '../../components';
import CommonBannerComponent from '../../components/common/CommonBannerComponent/CommonBannerComponent';
import CustomToolTip from '../../components/common/CustomToolTip';
import ForgotUsernameModal from '../../components/Modal/ForgotUsernameModal';
import appSettings from '../../appSettings';
import overrides from '../../common/theme/OverrideStyles';
import logo from './../../common/assets/img/agent-account-fp-image.png';
import '../../common/theme/UserFlowPage.scss';

const CiamIdRecoveryPage = ({toggleChatbot}) =>  {
    const [showModal, setShowModal] = useState(false);
    const defaultTheme = createTheme();
    const theme = createTheme(overrides);
    const initialFormValues= {
        username: '',
        dateofbirth: '',
    };
    const initialErrors = {
        username: '',
        dateofbirth: '',
    };

    const { formValues, setFormValues, errors, setErrors, isValid, setIsValid, setIsLoading, loaderStyle, showBannerType, setShowBannerType } = HandleFormUtil(initialFormValues, initialErrors, null);

    const handleInputChange = (event) => {
        handleFormInputChange(event, setFormValues);
    };

    const handleValidation = (event) => {
        handleFormValidation(event, setErrors, validationCheck);
    };

    const validationCheck = (inputValidator, inputValue) => {
        switch (inputValidator) {
            case 'username':
                return userNameValidation(inputValue);
            case 'dateofbirth':
                return dateValidation(inputValue);
            default:
                break;
        }
        return null;
    };

    const handleContinue = async () => {
        try {
            setIsLoading(true);
            setShowBannerType('');
            const resp = await fetchContactProfile('', '', formValues.username.toLowerCase());
            if(formatDate(resp?.contact?.dateofbirth) === formatDate(formValues.dateofbirth)) {
                window.location.replace(`${appSettings.AZURE_FORGOT_USER_ID}oauth2/authorize?client_id=${appSettings.AZURE_AD_CLIENT_ID}&redirect_uri=${appSettings.AZURE_AD_CLIENT_REDIRECT_URI}&response_type=id_token&scope=openid&login_hint=${resp.contact?.ciamId}`);
                return;
            }
            setShowBannerType('E300A');
            setIsLoading(false);
        } catch (e) {
            setShowBannerType('E900');
            setIsLoading(false);
            clearFormInput(initialFormValues, setFormValues);
        }
    };

    function toggleModal(){
        setShowModal(prevState => !prevState);
    }

    useEffect(() => {
        setIsValid(Object.values(formValues).some((value) => value === ''));    
    }, [showBannerType]);

    useEffect(() => {
        const formEmpty = Object.values(formValues).some((value) => value === '');
        const isErrorEmpty = Object.keys(errors).every((key) => errors[key] === '');
        setIsValid(isErrorEmpty && !formEmpty);    
      }, [errors]);

    useEffect(() => {
        const buttonElement = document.getElementById('amod-return-login-button');
        if (buttonElement) {
            buttonElement.style.display = 'block';
            buttonElement.addEventListener('click', () => {
                window.location.href = `${window.location.origin}/`;
            });
        } else {
            buttonElement.style.display = 'none';
        }
    }, []);

    return (
        <div className="userFlow agent-ciam-container">
            <div className="userFlow-container">

                <Grid container className="container-styling">
                    <Grid item sm={12} md={12} lg={5}>
                        <ImageComponent src={logo} />
                    </Grid>
                    <Grid item sm={12} md={12} lg={7} >
                        <div className="welcome-screen-para">
                            <div className="eyebrow">Recover Login ID | Step 1 of 3 </div>
                            <div className='title'>Verify your account</div>
                            <CommonBannerComponent bannerState='inline' bannerType={showBannerType} />
                            <p className='userFlow-content'>First, we need to verify your identity to keep your account secure.</p>


                            <ThemeProvider theme={defaultTheme}>
                                <form className='form-padding-to-continue-button'>
                                    <div className='userFlow-field'>
                                        <div className='userFlow-tooltip'>
                                            <label htmlFor='username' >
                                                Username
                                            </label>
                                            <ThemeProvider theme={theme}>
                                                <CustomToolTip message={<div className='tooltip-content'>If you are a new user, 'username' can be found in your Welcome email. If you are a returning user, please enter your modernLINK username.</div>}></CustomToolTip>
                                            </ThemeProvider>
                                        </div>
                                        <input
                                            id='username'
                                            className={`inputfield ${errors.username ? 'errorfocus' : ''
                                                }`}
                                            placeholder='Enter your username'
                                            onChange={handleInputChange}
                                            onBlur={handleValidation}
                                            value={formValues.username}
                                        />
                                        {errors.username && (
                                            <span className='errormsg'>{errors.username}</span>
                                        )}
                                    </div>
                                    <div className='dob' >
                                        <div>
                                            <label
                                                htmlFor='dateofbirth'
                                            >
                                                Date of birth
                                            </label>
                                            <input
                                                id='dateofbirth'
                                                type='date'
                                                onChange={(event) => handleDateChange(event, handleInputChange)}
                                                onBlur={handleValidation}
                                                value={formValues.dateofbirth}
                                                name='dob'
                                                className={`${
                                                    formValues.dateofbirth ? 'dob--has-value' :
                                                    errors.dateofbirth ? 'errorfocus' :
                                                    ''}`}
                                            />
                                            {errors.dateofbirth && (
                                                <span className='errormsg'>{errors.dateofbirth}</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className='forgot-username-link'>
                                        <Link
                                            className="login-link" onClick={toggleModal}>
                                            <span className="login-link-styling">Forgot your username?</span>
                                        </Link>
                                    </div>
                                </form>
                            </ThemeProvider>
                            <Button
                                disableRipple
                                disabled={!isValid} 
                                className='button-styling continue-button'
                                onClick={handleContinue}
                                style={loaderStyle}
                                aria-disabled={!isValid}
                            >
                                Continue
                            </Button>
                            <div className="existing-account-container">
                                <div>
                                    <div className="create-account">Have multiple usernames?</div>
                                    <p>If you have added more than one username to your account, you can use any one of them to recover your Login ID (Email)</p>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>

            {showModal && <ForgotUsernameModal toggleModal={toggleModal} toggleChatbot={toggleChatbot} />}
        </div>
    );
}


export default CiamIdRecoveryPage;
